import { render, staticRenderFns } from "./ProductConsumptionDetail.vue?vue&type=template&id=09c9e6ae&scoped=true&"
import script from "./ProductConsumptionDetail.vue?vue&type=script&lang=js&"
export * from "./ProductConsumptionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductConsumptionDetail.vue?vue&type=style&index=0&id=09c9e6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c9e6ae",
  null
  
)

export default component.exports